import { ColorByID, getColorsByID, hexToRgbArray, rgbToHsl } from './colorUtil';

type CourseLike = {
  azureId?: string | null;
  azureGroupId?: string | null;
  id?: string | null;
  color?: string | null;
  groupId?: string | null;
};

const getColor = (course: CourseLike): ColorByID => {
  if (course.color && course.color !== 'auto') {
    // Calendar for groups has a color prop set to "auto"
    return {
      colorOriginal: course.color,
      color: course.color,
      textColor: 'rgb(37, 36, 35)', // default text color
    };
  }

  const id = course.azureId || course.azureGroupId || course.groupId || course.id || '';
  return getColorsByID(id);
};

/**
 * Retrieves or generates a color that can be used as signal color
 * to easily diffentiate between a list of azure groups or courses.
 * Returns the lighter version of the color for better text contrast.
 */
export const getCourseColor = (course: CourseLike): string => {
  const { color } = getColor(course);

  return color;
};

/**
 * Creates a less saturated signal color for courses, that can be used to
 * draw text over it.
 */
export const getCourseBackgroundColor = (
  course: CourseLike,
  opacity = '1',
): string => {
  const color = getColor(course);
  const hslStr = lightenCourseColorForBackground(color.colorOriginal, opacity);
  return hslStr;
};

export const lightenCourseColorForBackground = (
  colorOriginal: string,
  opacity = '1',
) => {
  const colorArray = hexToRgbArray(colorOriginal);
  const hsl = rgbToHsl(colorArray[0], colorArray[1], colorArray[2]);

  // We use HSL colors since, we can easily manipulate color saturation
  const hslStr = `hsla(${Math.floor(hsl[0])}, ${Math.floor(
    hsl[1],
  )}%, 87%, ${opacity})`;

  return hslStr;
};

export const getCourseTextColor = (course: CourseLike): string => {
  const { textColor } = getColor(course);

  return textColor;
};
